import en from '@/locales/en'
import de from '@/locales/de.js'
import nl from '@/locales/nl.json'
import es from '@/locales/es.json'
import fa from '@/locales/fa.js'
import fr from '@/locales/fr.json'
import hu from '@/locales/hu.json'
import ja from '@/locales/ja.json'
import ko from '@/locales/ko.json'
import pt from '@/locales/pt.json'
import ru from '@/locales/ru.json'
import zh from '@/locales/zh.json'
import zhtw from '@/locales/zh_tw.json'

export default {
  de: de,
  en: en,
  es: es.default,
  fa: fa,
  fr: fr.default,
  hu: hu.default,
  ja: ja.default,
  ko: ko.default,
  nl: nl.default,
  pt: pt.default,
  ru: ru.default,
  zh: zh.default,
  zw: zhtw.default
}
